import { useCall } from "../useCall/useCall";

const ONE_MINUTE = 60;

export function useCallDurationRule() {
  const { call } = useCall();

  const isCallDurationLow = (call?.durationInSecond ?? Infinity) < ONE_MINUTE;
  const hasNoTranscript = !call?.transcription;

  const shouldDisplayCallDurationScreen = isCallDurationLow && hasNoTranscript;

  return {
    shouldDisplayCallDurationScreen,
    isCallDurationLow,
  };
}
